module.exports = __webpack_public_path__ + "static/12-b4a43091152e11ba05f45a4ea89a6fcd.png";